import React, { Component } from 'react';
import ChartWidget from './ChartWidget';
import { SimpleHorizontalSplitPane } from './SimpleSplitPane';
import './App.css';

class SplitpaneDividerButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = { locked: props.locked }
  }

  handleClick = () => {
    this.props.onClickCallback();
    this.setState({ locked: !this.state.locked })
  };

  render() {
    return (
      <div className="splitpane-dev-tools-button" onClick={this.handleClick}>
        <i className={this.state.locked ? "icon icon-locked" : "icon icon-unlocked"}></i>
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props)
    this.chartWidgetOneRef = React.createRef();
    this.chartWidgetTwoRef = React.createRef();

    this.chartOneID = "Left"
    this.chartTwoID = "Right"

    this.linkMap = {}
    this.linkMap[this.chartOneID] = {
      target: this.chartWidgetTwoRef
    }
    this.linkMap[this.chartTwoID] = {
      target: this.chartWidgetOneRef
    }

    this.widgetsAreLinked = false
  }

  handleSplitPaneResize = (indexOne, indexTwo) => {
    this.chartWidgetOneRef.current.handleResize()
    this.chartWidgetTwoRef.current.handleResize()
  }

  handleZoomOnPrimaryChart = (before, after, chartSourceID) => {
    if(this.widgetsAreLinked) {
      this.linkMap[chartSourceID].target.current.handleLinkedPrimaryZoom(before, after, chartSourceID)
    }
  }

  handleSplitPaneButtonPressed = () => {
    this.widgetsAreLinked = !this.widgetsAreLinked
    console.log(this.widgetsAreLinked)
  }

  render() {
    const divider = <SplitpaneDividerButton locked={false} onClickCallback={this.handleSplitPaneButtonPressed} />
    return (
      <div className="App">
        <div className={"debug-test-toolbar"} />
        <SimpleHorizontalSplitPane dividerContent={divider} onResize={this.handleSplitPaneResize} notifyChilds={true} cacheIdentifier="outerSplitPane">
          <ChartWidget chartWidgetID={this.chartOneID} onZoomPrimaryChart={this.handleZoomOnPrimaryChart} ref={this.chartWidgetOneRef} test="TestChartProp" />
          <ChartWidget chartWidgetID={this.chartTwoID} onZoomPrimaryChart={this.handleZoomOnPrimaryChart} ref={this.chartWidgetTwoRef} test="TestChartProp" />
        </SimpleHorizontalSplitPane>
      </div>
    );
  }
}

export default App;

/*
<div className="todo">
            <ul>
              <li className="todo-done proof">Change time format on smaller scales</li>
              <li className="todo-done proof">x-axis domain should always adapt to the current date/time</li>
              <li className="todo-done proof">Option to lock x-/y-axis scaling (for Gann and the like)</li>
              <li className="todo-done proof">Link zoom of two charts (optional)</li>
              <li className="todo-done proof">If chart window is scaled the chart should not be scaled</li>
              <li>Implement mouse cross hair</li>
              <li>Implement marker for axis (price/time)</li>
              <li>Clean up and optimization </li>
              <li>Splitview needs min/max sizes</li>
            </ul>
            ..Next steps dummy data
          </div> */


// WEBPACK FOOTER //
// ./src/App.js